export default "__VITE_ASSET__6da92f30__"